<template>
  <section v-if="cuisineGroupList?.length" class="categories-list mb-3 md:mb-10">
    <carousel
      navigator
      :title="$t('home.cuisine.title')"
      class="categories-list"
      :data="cuisineGroupList"
      :gap="gap"
      swiper-container-class="mt-2 md:mt-4"
    >
      <template #default="{ item: group }">
        <div class="flex flex-col md:gap-4">
          <locale-link
            v-for="item in group"
            :key="item.id"
            class="category flex flex-col items-center gap-2 w-25 md:w-30"
            :to="`/regions/${regionId}/categories/${item.id}`"
          >
            <etg-img
              class="category-image size-20 object-cover rounded-full md:size-25"
              :src="`fn:${item.cover_image || item.icon_image}`"
              :alt="item.name"
            />
            <p class="category-name text-sm min-h-10 text-center font-500 line-clamp-2 md:text-base md:min-h-12">{{ item.name }}</p>
          </locale-link>
        </div>
      </template>
      <template #skeleton>
        <div class="skeleton-wrapper flex gap-2 overflow-hidden mt-2 md:gap-8 md:mt-4">
          <div v-for="i in 7" :key="i" class="flex flex-col md:gap-4">
            <div v-for="j in chunkSize" :key="j" class="skeleton-card flex flex-col flex-none items-center gap-2 w-25 md:w-30">
              <n-skeleton class="size-20 rounded-full md:size-25" />
              <n-skeleton class="w-70% rounded h-5 mb-5 md:h-6 md:mb-6" text />
            </div>
          </div>
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'

import Carousel from '@/components/common/carousel.vue'

import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

import { useChunkedList } from '@/composables/useChunkedList'

const MAX_DISPLAY_COUNT = 20

const appStore = useAppStore()
const regionStore = useRegionStore()

const { regionInfo } = storeToRefs(regionStore)

const { regionId } = useRegion()

const cuisine = computed(() => regionInfo.value?.cuisine?.slice(0, MAX_DISPLAY_COUNT))
const gap = computed(() => (appStore.isDesktopScreen ? 32 : 8))

const { chunkSize, chunkedList: cuisineGroupList } = useChunkedList({ list: cuisine })
</script>
